import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUrl: string = environment.baseUrl
  imageUrl: string = environment.imageUrl;
  constructor(
    private http: HttpClient
  ) { }

  public postRequest(url: string, data: any) {
    console.log(`POST Request to: ${this.baseUrl + url}`);
    return this.http.post<any>(this.baseUrl + url, data, {}).pipe(
      tap(
        response => console.log('POST Response:', response),
        error => console.error('POST Error:', error)
      )
    );
  }

  public getRequest(url: string) {
    console.log(`GET Request to: ${this.baseUrl + url}`);
    return this.http.get(this.baseUrl + url, {}).pipe(
      tap(
        response => console.log('GET Response:', response),
        error => console.error('GET Error:', error)
      )
    );
  }

  public putRequest(url: string, data: any) {
    console.log(`PUT Request to: ${this.baseUrl + url}`);
    return this.http.put(this.baseUrl + url, data, {}).pipe(
      tap(
        response => console.log('PUT Response:', response),
        error => console.error('PUT Error:', error)
      )
    );
  }
  
  public deletRequest(url: string) {
    console.log(`DELETE Request to: ${this.baseUrl + url}`);
    return this.http.delete(this.baseUrl + url, {}).pipe(
      tap(
        response => console.log('DELETE Response:', response),
        error => console.error('DELETE Error:', error)
      )
    );
  }

  public patchRequest(url: string, data: any) {
    console.log(`PATCH Request to: ${this.baseUrl + url}`);
    return this.http.patch<any>(this.baseUrl + url, data, {}).pipe(
      tap(
        response => console.log('PATCH Response:', response),
        error => console.error('PATCH Error:', error)
      )
    );
  }

  public getBlobRequest(url: string) {
    console.log(`GET (blob) Request to: ${this.baseUrl + url}`);
    return this.http.get(this.baseUrl + url, { responseType: 'blob' });
  }
}
